/**
 * Ícone de sino com badge de notificações não lidas.
 * Abre a página de notificações ao clicar.
 */

import { Link } from 'react-router-dom'
import { useNotificationsStore } from '../model/notificationsStore'
import { BellIcon } from '@/shared/ui/icons'

export function BellMenu() {
  const unreadCount = useNotificationsStore((s) => s.items.filter((n) => !n.read).length)

  return (
    <Link
      to="/notifications"
      className="relative inline-flex h-9 w-9 items-center justify-center rounded-lg text-[var(--color-chrome-foreground)] transition-colors hover:bg-[var(--color-chrome-hover)]"
      aria-label={
        unreadCount > 0
          ? `${unreadCount} notificação${unreadCount === 1 ? '' : 'ões'} não lida${unreadCount === 1 ? '' : 's'}`
          : 'Notificações'
      }
      title={unreadCount > 0 ? `${unreadCount} não lida(s)` : 'Notificações'}
    >
      <BellIcon size={22} className="text-[var(--color-chrome-foreground)]" />
      {unreadCount > 0 ? (
        <span
          className="absolute -right-0.5 -top-0.5 flex min-w-[18px] items-center justify-center rounded-full bg-[var(--color-alert)] px-1 py-0.5 text-[10px] font-bold text-white"
          aria-hidden
          title={`${unreadCount} não lida(s)`}
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      ) : null}
    </Link>
  )
}
